import type { Group, Tween } from "@tweenjs/tween.js";
import * as PIXI from "pixi.js";
import React from "react";

export interface GameBoardOverlayInterface {
  addSpriteWithTween: (
    key: string,
    sprite: PIXI.Sprite,
    tweenOrGroup: Tween | Group,
    toPlayArea: boolean
  ) => void;
  removeSprite: (key: string, delayMs?: number) => void;

  setPlayArea: (playArea: { x: number; y: number; width: number; height: number }) => void;
  playArea: { x: number; y: number; width: number; height: number };
  isPlayAreaValid: () => boolean;
}

export const GameBoardOverlayContext = React.createContext<GameBoardOverlayInterface | null>(null);
